<template>
  <div class="NeighbourMoments">
    <div class="photocover" @click="changeCover">
      <img v-if="coverImg" :src="attach_url+coverImg" alt />
      <p v-else class="covertext">轻触更换主题照片</p>
    </div>
    <van-nav-bar fixed border :class="scroll>=300?'circletab1':'circletab'">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
      </template>
      <template #right>
        <img @click="imgShow()"
        style="width:30px;height:30px" src="../../assets/img/center/photo.png" alt=""/>
      </template>
    </van-nav-bar>
     <van-popup v-model="imgVideoShow" position="bottom" class="imgpopup">
          <p>
       <input ref="uploadVideo" type="file" @change="sendVideo" accept="video/*" id="fileUpload"
            capture="camcorder" style="opacity:0;width:100%;"/>
        <span>视频</span>
      </p>
      <p @click="totext">文本</p>
      <van-uploader class="uploadimg"  multiple capture :after-read="onSend" accept="image/*" :max-count="9">
      <p>图片</p>
      </van-uploader>
      <p style="margin-top:10px;" @click="closed">取消</p>
    </van-popup>
       <!-- 个人信息 -->
     <div class="user_head">
      <span class="username">{{userInfo.u_nickname?userInfo.u_nickname:userInfo.u_name?userInfo.u_name:userInfo.u_login_id}}</span>
      <img class="headimg" :src="attach_url+userInfo.u_headportrait" />
    </div>
    <van-popup v-model="showcover" position="bottom" class="coverpopup">
      <van-uploader class="uploadimg" capture :after-read="onSendCover" :before-read="beforeRead">
        <p class="change">更换相册封面</p>
      </van-uploader>
      <p @click="closed">取消</p>
    </van-popup>
       <!-- {{msgList}} -->
     <div v-if="msgstatus==1"></div>
     <div class="msgnotice" v-if="msgList!==undefined && msgList.length>0 && msgList[0].u_id!=u_id"  @click="tomsglist">
       <img v-if="msgList[0].status==7" class="headimg" :src="attach_url+msgList[0].comment.user.u_headportrait" alt="">
      <img v-else-if="msgList[0].status==6" class="headimg" :src="attach_url+msgList[0].userinfo.u_headportrait" alt="">
        <span class="count">{{msgList.length}}条信息</span> 
      </div>
      <div v-else>
        <div class="msgnotice" @click="tomsglist" v-if="newmsgshow && newmsgList!==null && newmsgList.length>0">
         <img  class="headimg" :src="attach_url+newmsgList[0].u_headportrait" alt="">
          <span v-if="msgshowLists" class="count">{{msgshowLists.length}}条信息</span> 
        </div>
        </div>
     <div class="user-content" v-for="(item,index) in FriendcircleList" :key="index">
       <img class="headimg" :src="attach_url+item.users.u_headportrait" alt />
        <div class="detail">
        <h2 class="username">{{item.users.u_nickname?item.users.u_nickname:item.users.u_name?item.users.u_name:item.users.u_login_id}}</h2>
        <p class="articletitle">{{item.content}}</p>
        <span class="content" v-if="item.picture!==undefined && item.picture.indexOf('.mp4') != -1 " >
          <div class="video-box"  @click.stop="playVideo(attach_url+item.picture)">
           <img class="videocover" style="height:180px;width:130px;margin-left:15%;" :src="attach_url+item.picture.replace('mp4', 'jpg')" alt />
           <div class="video-img"></div>
          <div :class="videoshow==true? 'videoshow1':'videoshow'">
           <video :src="videoUrl" ref="msgvideo" style="width:200px;height:160px;" preload="auto"></video>
        </div>              
       </div>
        </span>
        <span class="content" v-else-if="item.picture=='undefined'"></span>
        <span class="content" v-else>
          <img  :class="item.picture.split(',').length>1?'contentimg':'contentimg1'" 
            v-for="(itt,i) in item.picture.split(',')" :key=i  :src="attach_url+itt" 
             @click.stop="showImage(attach_url+itt)"
            alt />
        </span>
        <div class="commentmange">
           <div class="comtime">
            <span class="time">{{getTimer(item.create_time)}}</span>
            <!-- <span>{{item.create_time}}</span>  -->
            <span v-if="item.users.u_id == u_id" @click="del(item.id,index)" class="delate">删除</span>
           </div>
          <div class="likeshow" v-show="item.showComt">
            <div class="like" @click="clickLike(item,index,item.id,item.u_id)">
              <img src="../../assets/like.png" alt />
              <span v-if="check(item.like)">取消</span>
              <span v-else>赞</span>
            </div>
            <div class="like1" @click="commentclick(item,item.id,item.u_id)">
              <img src="../../assets/comment.png" alt />
              <span>评论</span>
            </div>
          </div>
          <img
            @click="commentshow(item,index)"
            class="commentimg"
            src="../../assets/comment.png"
            alt
          />
        </div>
        <div class="total">
          <div class="userlike">
            <img
              class="likeicon"
              v-if="item.like.length"
              src="../../assets/img/center/like.png"
              alt
            />
            <span v-for="(it,i) in item.like" :key="i" class="likename">
              {{it.u_nickname?it.u_nickname:it.u_name?it.u_name:it.u_login_id}}
            </span>
          </div>
          <div class="commenttotal">
            <img
              v-if="item.comments.length"
              class="commenticon"
              src="../../assets/img/center/comment.png"
              alt
            />
            <div class="commentdetail">
              <div class="usercomment" v-for="(it,i) in item.comments" :key="i">
                <!-- {{it}} -->
                <img class="commentimg" :src="attach_url+it.user.u_headportrait" alt />
                <!-- <div @click="replyMsg(it.id,it.user.u_id,it.fcmid,item.u_id)" class="usertext"> -->
                <div
                  @click="replyMsg(it,it.id,it.user.u_id,it.tou_id,it.fcmid,item.u_id)"
                  class="usertext"
                >
                  <div class="text">
                    <span class="commentname">{{it.user.u_nickname?it.user.u_nickname:it.user.u_name?it.user.u_name:it.user.u_login_id}}</span>
                    <span class="commenttime">{{it.create_time.split(' ')[1]}}</span>
                  </div>
                  <p class="commenttext">
                    <span v-if="it.touser">
                      回复
                      <span
                        class="touser"
                      >{{it.touser.u_nickname?it.touser.u_nickname:it.touser.u_login_id}}:</span>
                    </span>
                    <span class="replycon" v-html="analyzeEmoji(it.content)"></span>
                    <!-- {{it.content}} -->
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="commentdelate" position="bottom" class="coverpopup">
      <p class="change" @click="delComment">删除</p>
      <p @click="closed">取消</p>
    </van-popup>
     <van-dialog
      v-model="showImgDialog"
      :showConfirmButton="false"
      :closeOnClickOverlay="true"
      class="img_dialog"
      @click="showImgDialog=false"
    >
      <img :src="image_url" style="width:100%;" @click="showImgDialog=false" />
      <!-- @touchstart="start1()" -->
    </van-dialog>
    <div class="bottom-bar" v-if="tabbarshow">
      <div class="v-tabbar">
        <van-field
          class="sendc"
          v-model="content"
          :clearable="true"
          border
          :placeholder="banned==true?definte1:definte"
          type="textarea"
          autosize
        />
        <img class="face" src="../../assets/img/icon/face.png" alt @click="showface()" />
        <van-button class="send" :style="{ width: '20%'}" type="info" @click="sendmsg">发送</van-button>
      </div>
       <div v-show="faceshow" class="faceshow">
        <van-icon
          size="8"
          v-for="item in OwOlist"
          :key="item+''"
          :name="getOwOlistUrl()+item.url"
          @click="selectOwO(item.title)"
        />
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { chkImgType } from "@/utils/common.js";
import { OwOlistUrl,analyzeEmoji,emojiList,compUploadImg, } from "@/utils/chat.js";
export default {
  name: "NeighbourMoments",
  data() {
    return {
      title: "朋友圈",
      items: [],
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre,
      userInfo:JSON.parse(localStorage.getItem("userInfo")),
      likeshow: false,
      headimg: "",
      headname: "",
      showcomment: "",
      coverImg: "",
      showcover: false,
      tabbarshow: false,
      content: "",
      fclid: "",
      replyid: "",
      commentdelate: false,
      delcomid: "",
      touserid: "",
      fcuid: "",
      faceshow:false,
      OwOlist: emojiList,
      definte: "评论",
      definte1:"",
      banned:false,
      replyname:"",
      scroll:"",
      headportrait:"",
      username:"",
      imgVideoShow:false,
      imageList:[],
      current:0,
      showImgDialog:false,
      image_url:"",
      videoUrl:"",
      videoshow:false,
      text:{},
      msgShowList:[],
      newMsgShow:JSON.parse(localStorage.getItem("newMsgShow")),
      connected: false,
      circlecountUnread:JSON.parse(localStorage.getItem("circlecountUnread")), 
      newmsgList:JSON.parse(localStorage.getItem("newmsgList")), 
      newmsgshow:true,
      msgshowLists:JSON.parse(localStorage.getItem("msgshowLists")),
      msgList:[],
      msgstatus:"",
      FriendcircleList:[],
			chkWebsocketTimer:false,
			  videoLengthLimit:20,
			  videoSizeLimit:10 * 1024 * 1024,
			  sendMsgList:[],
			  sendMsgTimer:null
    };
  },
  mounted() {
		this.connected = this.websocket.connected;
    // 获取浏览器可视区域高度
    this.winH = `${document.documentElement.clientHeight}`;
    window.onresize = function temp() {
      this.winH = `${document.documentElement.clientHeight}`;
    };
    window.addEventListener('scroll', this.scrollTop)
  },
  created() {
    
	this.chkSocketState();

	this.getStateConfigs();
    this.FriendcircleList = [];
    this.loadData();
    this.getCover();
    this.msgstatus = this.$route.query.msgstatus;
	
	this.sendMsgTimer = setInterval(function() {
		if (this.websocket.connected) {
			var m = sendMsgList.shift();
			if(m){
				this.websocket.ws.send(JSON.stringify(m));
			 }
		}
	}, 1000);
  },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
				if (confs.videoLength){
					this.videoLengthLimit = parseInt(confs.videoLength.values);
				}
				if (confs.videoSize){
					this.videoSizeLimit = parseInt(confs.videoSize.values);
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    loadData(){
      var params = {
        u_id: this.u_id,
        token: this.token,
        num: Math.random(),
      };
      var url = this.Conf.serverUrl + "FriendCircle/selectFriendCircle";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then((response) => {
          // console.log("hhhhhh",response);
          for (var i in response.data.friendCircle) {
            response.data.friendCircle[i].showComt = false;
            this.FriendcircleList.push(response.data.friendCircle[i]);
          }
        })
       .catch((error) => {});
    },
    scrollTop(){
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    },
    check(like) {
      for (var i in like) {
        if (like[i].u_id == this.u_id) {
          return true;
        }
      }
    },
    //取出封面图
    getCover() {
      var params = {
        u_id: this.u_id,
        token: this.token,
        num: Math.random(),
      };
      var url = this.Conf.serverUrl + "FriendCircle/selectBanner";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then((response) => {
          this.coverImg = response.data.banner_url;
        })
        .catch((error) => {});
    },
    changeCover() {
      this.showcover = true;
    },
    closed() {
      this.showcover = false;
      this.commentdelate = false;
      this.imgVideoShow = false;
    },
    goBack() {
      this.$router.push({
        name: "My",
        query: {
          active: 3,
        },
      });
    },
    // 点赞以及取消点赞
    clickLike(item, index, id, uid) {
       //console.log(item, index, id, uid);
       var tag = 'like';
      for (var i in item.like) {
        if (item.like[i].u_id == this.u_id) {
           tag = "cancel";
          //  alert(tag);
        }
      }
      item.showComt = !item.showComt;
      var data = {
        u_id: this.u_id,
        token: this.token,
        id: id,
        num: Math.random(),
      };
      var url = this.Conf.serverUrl + "FriendCircle/likeFriendCilcle";
      this.$axios
        .post(url, this.$qs.stringify(data))
        .then((response) => {
          // item.like.push(item.users);
          var data = {
            fcmid: id,
            fcuid: uid,
            u_id: this.u_id,
            mk: 12,
            status: "like",
            tag:tag,
            //tag:item.clike,
          };
		  this.sendMsgList.push(data)
        })
        .catch((error) => {});
    },
    //点击评论按钮
    commentclick(item, id, uid) {
      item.showComt = !item.showComt;
      this.tabbarshow = true;
      this.fclid = id;
      this.fcuid = uid;
    },
    showface() {
      this.faceshow = true;
    },
    // 选择表情包
    selectOwO(title) {
      this.content += title;
    },
    // 获取表情包url前缀
    getOwOlistUrl() {
      return OwOlistUrl;
    },
    analyzeEmoji(cont) {
      return analyzeEmoji(cont);
    },
    // 发朋友圈时第一步点击
    imgShow(){
      this.imgVideoShow = true;
    },
    //点击图片时去放大图片
     showImage(img) {
      this.showImgDialog = true;
      this.image_url = img;
    },
    // 监听服务端push回来的socket消息
    getMessage(msg) {
		var that = this;
		var data = JSON.parse(msg.data);
		if (data && data.m_type == "alert") {
			that.$toast(data.m_post_messages);
			return;
		}
      
      switch (data.status) {
        case 1:
        case 2:
          // 重新连接socket fd改变，客户端与服务端token相等时，不退出登入
          if (this.token == data.token) {
            return;
          }
          // 用户在别处登录，客服端与服务端token不相等时
          // 客户端token 与 后台token不相等时，退出登入
          window.localStorage.clear();
          this.$dialog
            .alert({
              message: data.message,
            })
            .then(() => {
              // on close
              this.$router.push({ path: "/login" });
            });
          break;
        case 6:
         
          //只push到当前点赞
          for (var i in this.FriendcircleList){
            if (this.FriendcircleList[i].id == data.fcmid) {   
            var index = this.checkArr(this.FriendcircleList[i].like, data.userinfo);
              if (index) {
                this.FriendcircleList[i].like.splice(index, 1);
               }else{
                this.FriendcircleList[i].like.push(data.userinfo);
                if(data.userinfo.u_id!==this.u_id){
                    this.msgShowList.unshift(data);
                  localStorage.setItem("msgList", JSON.stringify(this.msgShowList));
                  this.msgList=JSON.parse(localStorage.getItem("msgList"));  
                }
                  
              }
            }
          }  
        
           
          break;
        case 7:
          //只push到当前评论
          for (var i in this.FriendcircleList) {
            if (this.FriendcircleList[i].id == data.fcmid ) {
              this.FriendcircleList[i].comments.push(data.comment);
               if(data.u_id!==this.u_id){
                    this.msgShowList.unshift(data);
                  localStorage.setItem("msgList", JSON.stringify(this.msgShowList));
                    this.msgList=JSON.parse(localStorage.getItem("msgList"));   
                }
            }
          }
          break;
         case 8:
          //删除评论
          for (var i in this.FriendcircleList) {
            for (var index in this.FriendcircleList[i].comments) {
              var delItem = this.FriendcircleList[i].comments[index];
                if (delItem.id == data.comment_id) {
                const delIndex = this.FriendcircleList[i].comments.findIndex(
                  (delItem) => delItem.id === data.comment_id
                );
                this.FriendcircleList[i].comments.splice(delIndex, 1);
              }
            }
          }
          break;
			case 99:
				that.$toast('你有一条新的'+data.message);
				break;
			default:
				break;
        } 
    },
    tomsglist(){
      this.newmsgshow = false;
      this.$router.push({
        name: "NeighbourNewMsg",
      });
    },
    checkArr(arr, data) {
      for (var i in arr) {
        if (arr[i].u_id == data.u_id) {
          return i;
        }
      }
    },
    //点击每一条评论的时候
    replyMsg(it,id, userid, tou_id, fclid, fcuid) {
      console.log("kkk", it,id, userid, tou_id, fclid, fcuid);
      if (userid == this.u_id) {
        this.commentdelate = true;
        this.tabbarshow = false;
        this.replayid = id;
        this.fclid = fclid;
        this.fcuid = fcuid;
        this.touserid = tou_id;
      } else {
        this.replyname=it.user.u_nickname?it.user.u_nickname:it.user.u_name?it.user.u_name:it.user.u_login_id;
        this.definte1="回复"+this.replyname;
        this.banned=true;
        this.tabbarshow = true;
        this.replayid = id;
        this.fclid = fclid;
        this.touserid = userid;
        this.fcuid = fcuid;
        // console.log(this.replyname);
      }
    },
    //发送评论
    sendmsg() {
      let that = this;
      if (!that.chkSocketState()) {
        return that.$toast("连接马上建立，请稍候...！");
      }
      that.faceshow = false;
      if (
        that.content.trim() == "" ||
        that.content == null ||
        typeof that.content == "undefined"
      ) {
        return that.$toast("输入不能为空！");
      } else {
        var data = {
          u_id: that.u_id,
          token: that.token,
          content: that.content,
          fcmid: that.fclid,
          p_id: that.replayid,
          tou_id: that.touserid,
          num: Math.random(),
        };
        // console.log("hehhe", data);
        var url = that.Conf.serverUrl + "FriendCircle/commontFriendCircle";
        that.$axios
          .post(url, that.$qs.stringify(data))
          .then((response) => {
            console.log("aaaa", response);
            switch (response.data.code) {
              case 200:
                var data = {
                  fcmid: response.data.comment.fcmid,
                  fcuid: that.fcuid,
                  u_id: response.data.comment.u_id,
                  touid: that.touserid,
                  mk: 12,
                  comment: response.data.comment,
                  status: "comment",
                };
				that.sendMsgList.push(data)
                that.content = "";
                that.tabbarshow = false;
                break;
              case 40001:
                that.$toast.fail("评论失败！");
                break;
            }
          })
          .catch((error) => {});
      }
    },
    //删除自己的评论
    delComment() {
      this.commentdelate = false;
      let that = this;
      var data = {
        u_id: that.u_id,
        token: that.token,
        id: that.replayid,
        num: Math.random(),
      };
      // console.log("oooo", data);
      var url = that.Conf.serverUrl + "FriendCircle/delComment";
      that.$axios
        .post(url, that.$qs.stringify(data))
        .then((response) => {
          // console.log("iuiuiui", response);
          switch (response.data.code) {
            case 200:
              var data = {
                fcmid: that.fclid,
                fcuid: that.fcuid,
                u_id: that.u_id,
                touid: that.touserid,
                comment_id: that.replayid,
                status: "delcomment",
                mk: 12,
              };
              // console.log("tttt", data);
			  
				that.sendMsgList.push(data)
              break;
            case 40001:
              that.$toast.fail("删除失败！");
              break;
          }
        })
		.catch((error) => {});
    },
	chkSocketState() {
		if ( this.websocket && this.websocket.ws && this.websocket.ws.readyState == 1 ) {
			// 监听消息回调
			this.connected = true;
			this.websocket.ws.onmessage = this.getMessage;
			if (this.latestInterTmer) {
				clearInterval(this.latestInterTmer);
			}
		}else{
			this.connected = false;
		}
		this.chkWebsocketTimer && clearTimeout(this.chkWebsocketTimer)
		this.chkWebsocketTimer = setTimeout(() => {
			this.chkSocketState();
		}, 2000);
	},
    commentshow(item, index) {
      item.showComt = !item.showComt;
    },
    beforeRead(file) {
      return chkImgType(file);
    },
    // 上传图片
    onSend(file) {
      let that = this;
       that.imgVideoShow = false;
      compUploadImg(file, function (f) {     
        let data = {};
        data.message = file.content;
        data.friend_id = that.friend_id;
        data.u_id = that.u_id;
        data.mk = 3;
        data.type = "image";
        var url = that.Conf.serverUrl + "Chat/uploadImg" + "?num=" + Math.random();
        that.$axios
          .post(url, that.$qs.stringify(data))
          .then((response) => {
            console.log("aaaa",response);
            that.$router.push({
              name: "NeighbourEdit",
              query: {
                headimg: response.data,
              },
            });
          })
          .catch((error) => {});
      });
    },
    totext(){
     this.imgVideoShow = false;
      this.$router.push({
                name: "NeighbourEdit",
              query: {
                headimg:this.text,
              },
       });
    },
    playVideo(src) {
      var that = this;
       that.imgVideoShow = false;
      that.videoshow = true;
      that.videoUrl = src;
       var video = that.$refs.msgvideo[0];
      if(video.paused) {
        that.FullSrceen();
        that.$nextTick(() => {
          video.play();
        });
        video.addEventListener("ended", () => {
          that.videoshow = false;
          video.load();
          that.exitFullscreen();
        });
        document.addEventListener("fullscreenchange", function (e) {
          if (document.fullscreenElement) {
            video.play();
          } else {
            that.videoshow = false;
            video.pause();
          }
        });
        document.addEventListener("webkitfullscreenchange", function (e) {
          const isFullScreen =
            document.fullscreenEnabled ||
            window.fullScreen ||
            document.webkitIsFullScreen ||
            document.msFullscreenEnabled;
          if (isFullScreen) {
            video.play();
          } else {
            that.videoshow = false;
            video.pause();
            // video.load();
          }
        });
      }
    },
    //进入全屏
    FullSrceen() {
      var video = this.$refs.msgvideo[0];
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullScreen) {
        video.webkitRequestFullScreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      } else {
        this.videoshow = false;
        video.play();
      }
    },
    //退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.oRequestFullscreen) {
        document.oCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },
    onSendCover(file) {
      // console.log("kkkk", file);
      this.showcover = false;
      let that = this;
      compUploadImg(file, function (f) {
        let data = {};
        data.u_id = that.u_id;
        data.token = that.token;
        data.banner = file["content"];
        var url = that.Conf.serverUrl +  "FriendCircle/uploadBanner" + "?num=" + Math.random();
        that.$axios
          .post(url, that.$qs.stringify(data))
          .then((response) => {
            that.coverImg = response.data.banner_url;
          })
          .catch((error) => {});
      });
    },
     //上传视频
    sendVideo() {
      if (!this.chkSocketState()) {
        return this.$toast("连接马上建立，请稍候...！");
      }
      var that = this;
      that.imgVideoShow = false;
		  let filesize = this.videoSizeLimit;
		  let filelength = this.videoLengthLimit;
      var file = that.$refs.uploadVideo.files[0];
      var formData = new FormData();
      if (file.size > filesize) {
        that.$toast("视频不能超过" + filesize / (1024 * 1024) + "M");
        return;
      } else if (file.length > filelength) {
        that.$toast("视频不能超过" + filelength + "s");
        return;
      } else {
        that.$toast("请稍候...");
        formData.append("video", file);
        let headers = { "Content-Type": "multipart/form-data" };
        that.videoFlag = true;
        var url = this.Conf.serverUrl + "Chat/uploadVideo";
        that.$axios
          .post(url, formData, headers)
          .then((response) => {
            // console.log(response);
           that.$router.push({
              name: "NeighbourEdit",
              query: {
                headimg: response.data,
                // .imageUrl,
                // type:response.data.type
              },
            });
           
          })
          .catch((err) => {});
      }
    },
    //删除朋友圈
    del(id, index) {
      //  console.log("pppp",id);
      var params = {
        u_id: this.u_id,
        token: this.token,
        id: id,
        num: Math.random(),
      };
      var url = this.Conf.serverUrl + "FriendCircle/delFriendCircle";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then((response) => {
          if (response.data.code == 200) {
            this.FriendcircleList.splice(index, 1);
          } else {
            this.$toast("删除失败");
          }
        })
        .catch((error) => {});
    },
    //将时间转化为几分钟，几小时前
    getTimer(stringTime) {
      var minute = 1000 * 60;
      var hour = minute * 60;
      var day = hour * 24;
      var week = day * 7;
      var month = day * 30;
      var time1 = new Date().getTime(); //当前的时间戳
      // console.log(time1);
      var time2 = Date.parse(new Date(stringTime)); //指定时间的时间戳
      // console.log(time2);
      var time = time1 - time2;
      var result = null;
      if (time < 0) {
        // alert("设置的时间不能早于当前时间！");
      } else if (time / month >= 1) {
        result = parseInt(time / month) + "月前";
      } else if (time / week >= 1) {
        result = parseInt(time / week) + "周前";
      } else if (time / day >= 1) {
        result = parseInt(time / day) + "天前";
      } else if (time / hour >= 1) {
        result = parseInt(time / hour) + "小时前";
      } else if (time / minute >= 1) {
        result = parseInt(time / minute) + "分钟前";
      } else {
        result = "刚刚发布！";
      }
      return result;
    },
  },
  beforeDestroy(){
		if (this.chkWebsocketTimer) clearTimeout(this.chkWebsocketTimer);
		if(this.sendMsgTimer){clearInterval(this.sendMsgTimer);}
  },
  destroyed(){
    window.removeEventListener('scroll', this.scrollTop);
  }
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/My/NeighbourMoments.vue